/**
 * Ce qu'un rendu a à montrer (pur) : lu par `<ActivityWork>`, qui ne rend rien quand il n'y a rien, et par
 * l'écran qui le pose, pour dire « Pas encore de rendu » à la place d'un cadre vide. Testé à côté.
 */
import { type UIActivityWork } from "../../../ports/primary/ui/types/activityDetails"

/**
 * La copie nue : les pages brutes, ou les photos sans l'image corrigée qui les précède (la correction est
 * la première image, l'ordre du legacy). Ce que montre `hideCorrection`, et ce qu'un écran compte pour
 * savoir s'il reste quelque chose à montrer.
 */
export function bareWorkImages(work: UIActivityWork): string[] {
    return work.copyPages ?? (work.hasCorrection === true ? work.images.slice(1) : work.images)
}

/**
 * Le rendu montre quelque chose : une photo (la copie nue quand la correction est cachée) ou un
 * enregistrement. Un rendu annoncé sans rien de lisible (aucune photo retrouvée, un oral sans son fichier)
 * ne montre rien.
 */
export function activityWorkShows(work: UIActivityWork | null | undefined, hideCorrection = false): boolean {
    if (work == null) return false
    const images = hideCorrection ? bareWorkImages(work) : work.images
    return images.length > 0 || (work.audioUri != null && work.audioUri !== "")
}
